<template>
  <div class="">
    <v-select
      v-model="forms"
      :options="formsOptions"
      :clearable="false"
      multiple
      @input="onChange"
      @search="onSearch"
      :disabled="isSelectDisabled"
    />
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";
import {debounce} from "lodash";
import axios from "@axios";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    fieldOptions: Object,
    context: Object
  },
  setup(props, { emit }) {
    const search = ref("");
    const limit = ref(8);
    const forms = ref(false);
    const options = ref(null);
    const isSelectDisabled = ref(false);
    const formsOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.id,
        label: u.reference || u.name,
      }))
    );

    onMounted(() => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      forms.value = props.context.model
      fetchData()
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get("/v1/operational-security-forms/template-answers", {
          params: {
            q: search.value,
            max: limit.value,
            sortBy: 'id',
            completedForms: true,
          },
        });
        const currentFormId = props?.fieldOptions?.formId ?? 0
        options.value = data.data.filter(item => item.id !== currentFormId);
      } catch (error) {
        console.error(`forms: request error`, error?.response || error);
      }
    }

    async function onChange(value) {
      props.context.model = value
    }


    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        await fetchData();
        loading(false);
      } else {
        search.value = '';
        await fetchData();
      }
    }, 500);

    return {
      forms,
      formsOptions,
      isSelectDisabled,
      onSearch,
      onChange
    }
  }
}
</script>